(function( app, subscriptionPlanForm, $, undefined ) {
  'use strict';

  app.data ||= {}
  app.data.stripeProducts ||= []

  var stripeProductElement = null
  var stripeProductNameElement = null
  var stripePriceElement = null
  var stripePriceIdElement = null
  var stripePriceDefaultTaxBehaviorElement = null
  var stripePriceDefaultCurrencyElement = null
  var stripePriceRecurentIntervalElement = null
  var stripePriceIntervalCountElement = null
  var stripeCurrencyOptionsElement = null
  var stripePriceRecurentIntervalElementDisplay = null
  var initialLoad = true

  var accessTypeElement = null

  const autocompleteEndpoints = {
    'clubready_packages': '/admin/api/v1/clubready_packages'
  }
  const formElements = {
    'clubready_packages_selector': '#subscription_plan_clubready_package_ids',
  }
  // Public Method
  subscriptionPlanForm.initForm = function() {
    _initAccessTypes()
    _initStripeSelections()
    _initClubreadyPackages()
  }

  // INIT Stripe Selections 
  function _initStripeSelections() {
    stripeProductElement = $('#subscription_plan_stripe_product_id')
    stripeProductNameElement = $('#subscription_plan_stripe_product_name')
    stripePriceElement = $('#subscription_plan_stripe_default_price_amount')
    stripePriceIdElement = $('#subscription_plan_stripe_default_price_id')
    stripePriceDefaultTaxBehaviorElement = $('#subscription_plan_stripe_default_price_tax_behavior')
    stripePriceDefaultCurrencyElement = $('#subscription_plan_stripe_default_price_currency')
    stripeCurrencyOptionsElement = $('#subscription_plan_stripe_currency_options_flatten_ids')
    stripePriceRecurentIntervalElement = $('#subscription_plan_stripe_price_recurring_interval')
    stripePriceIntervalCountElement = $('#subscription_plan_stripe_price_interval_count')
    stripePriceRecurentIntervalElementDisplay = $('#subscription_plan_stripe_price_recurring_interval_display')
    
    // Stripe Products Dropdwon
    stripeProductElement.select2({
      placeholder: 'Select Stripe Product ...',
      allowClear: true
    }).on('select2:select', function (e) {
      _stripePlanChangeEvent(e)
    }).on('select2:unselecting', function (e) {
      stripeProductNameElement.val('')
      _clearPriceElements()
    }) 

    // Stripe Price Dropdown
    stripePriceIdElement.select2({
      placeholder: 'Select Stripe Product and then Stripe Price ...',
      allowClear: true
    }).on('select2:select', function (e) {
      _stripePriceChangeEvent(e)
    }).on('select2:unselecting', function (e) {
      _clearPriceElements()
    }) 

    stripeCurrencyOptionsElement.select2({
      placeholder: 'Select Additional Currencies ...',
      allowClear: true
    // }).on('select2:select', function (e) {
    //   console.log('Additional Currency Addded')
    // }).on('select2:unselecting', function (e) {
    //   console.log('Additional Currency Removed')
    })

    _fetchStripePlans()
  }

  // INIT Access Types 
  function _initAccessTypes() {
    accessTypeElement = $('#subscription_plan_access_type_perm')

    accessTypeElement.select2({
      default: 'all',
      allowClear: false
    })

    accessTypeElement.on('select2:select', function (e) {
      _changeAccessTypePerm(e)
    });
  }

  // INIT Clubready Packages
  function _initClubreadyPackages() {
    // Change Offer Type Listener
    $(formElements['clubready_packages_selector']).select2({
      placeholder: 'Select ClubReady Packages ...',
      allowClear: false,
      minimumInputLength: 2,
      ajax: {
        url: autocompleteEndpoints['clubready_packages'],
        dataType: 'json',
        data: function (params) {
          var query = {
            search: params.term
          }
          // Query parameters will be ?search=[term]
          return query;
        },
        processResults: function (data) {
          return {
            results: data
          };
        }
      }
    })

    // Populate the Selected Element - this is on page load
    // It's done this way as limitation with select2 and ajax search
    var populateSelectedResources = app.subscriptionPlan.selectedCrPackages
    if(populateSelectedResources.length > 0 && initialLoad){
      //$(formElements['clubready_packages_selector']).val(null).trigger('change');
      populateSelectedResources.forEach( function(cr_package){
        var newOption = new Option(cr_package.text, cr_package.id, true, true);
        $(formElements['clubready_packages_selector']).append(newOption)
      })
      $(formElements['clubready_packages_selector']).trigger('change');
      initialLoad = false
    }
  }

  function _changeAccessTypePerm() {
    var access = accessTypeElement.val()    
    if(!access){
      return
    }
    
    var brandElement = $('#subscription_plan_brand_id')

    if(access == 'all'){
      brandElement.attr('disabled','disabled')
      brandElement.val(null).trigger('change'); 
    }
    else{
      // brandElement.attr('disabled','') - IDK Not working
      // brandElement.trigger('change'); // trigger('select2:select'); - IDK Not working
      brandElement.prop('disabled', false);
    }
  }

  // Fetch Stripe Products -> Prices
  function _fetchStripePlans() {
    var url = '/admin/api/v1/stripe_products'
    $.ajax({
      url: url,
      type: "GET",
      dataType: "json",
      success: function (resp) {
        app.data.stripeProducts = resp
        _appendStripeProductsToList(resp)
      },
      error: function (xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")");
        console.log('SERVER RESPONDED WITH ERROR >>>', err.Message);
      }
    });
  };

  // Append Stripe Products
  function _appendStripeProductsToList(products) {
    var selectedValue = stripeProductElement.val()
    // Clear Existing Select if there is a value
    products.sort((a, b) => a.product_name > b.product_name ? 1 : -1).forEach( function(product){
      // This option is already in the dropdown
      if(selectedValue == product.stripe_product_id){
        return
      }
      var newOption = new Option(product.product_name, product.stripe_product_id, false, false);
      stripeProductElement.append(newOption)
    })

    // Refresh List
    stripeProductElement.trigger('change');
    stripeProductElement.trigger('select2:select');
  }

  function _stripePlanChangeEvent(event) {
    // On Initial Render with New Error or Edit we need to get the value from stripeProductIdHiddenElement
    var selectedStripeProductID = stripeProductElement.val()
    
    if(selectedStripeProductID == '' || selectedStripeProductID == null || selectedStripeProductID == undefined){
      return
    }
    const stripeProduct =  app.data.stripeProducts.find(x => x.stripe_product_id === selectedStripeProductID)
    stripeProductNameElement.val(stripeProduct.product_name)

    _populateStripePricesToList(stripeProduct.prices)
  }
  
  // Append Stripe Prices
  function _populateStripePricesToList(prices) {
    var selectedValue = stripePriceIdElement.val()
    var newProductsList = true
    stripePriceIdElement.empty() // Clear the List

    prices.sort((a, b) => a.stripe_price > b.stripe_price ? 1 : -1).forEach( function(price){
      // This option is already in the dropdown
      if(selectedValue == price.stripe_price_id){
        newProductsList = false
      }
    })

    // Refresh List
    if(newProductsList){
      _clearPriceElements()
      selectedValue = ''
    }

    prices.sort((a, b) => a.stripe_price > b.stripe_price ? 1 : -1).forEach( function(price){      
      var price_amount = _formatAmount(price.stripe_price, price.currency)
      var label = price_amount + " / " + _generatePriceRecurrentIntervalLabel(price.recurrence.interval, price.recurrence.interval_count)
      var newOption = new Option(label, price.stripe_price_id, false, false);
      stripePriceIdElement.append(newOption)
    })

    // Clear & Disable the Currencies List

    // Refresh List 
    stripePriceIdElement.val(selectedValue).trigger('change');
    stripePriceIdElement.trigger('select2:select');
  }

  function _stripePriceChangeEvent(event) {
    // Case1: No Product Selected
    var selectedStripeProductID = stripeProductElement.val()
    if(selectedStripeProductID == '' 
        || selectedStripeProductID == null 
        || selectedStripeProductID == undefined
      ){
      return
    }
    const stripeProduct =  app.data.stripeProducts.find(x => x.stripe_product_id === selectedStripeProductID)

    // Case2: No price Selected
    var selectedStripePriceID = stripePriceIdElement.val()
    if(selectedStripePriceID == '' 
      || selectedStripePriceID == null 
      || selectedStripePriceID == undefined
    ){
      return
    }

    const stripePrice = stripeProduct.prices.find(x => x.stripe_price_id === selectedStripePriceID)

    // Recurrent Interval
    stripePriceRecurentIntervalElement.val(stripePrice.recurrence.interval)
    stripePriceIntervalCountElement.val(stripePrice.recurrence.interval_count)
    stripePriceRecurentIntervalElementDisplay.html(
      _generatePriceRecurrentIntervalLabel(stripePrice.recurrence.interval, stripePrice.recurrence.interval_count)
    )
    // Currency
    stripePriceDefaultCurrencyElement.val(stripePrice.currency)
    // Set up Stripe Price Amount - hiddent field for display purpose
    stripePriceElement.val(stripePrice.stripe_price)
    // Set up Stripe Price Default Tax 
    stripePriceDefaultTaxBehaviorElement.val(stripePrice.tax_behavior)
    // Set up Stripe Additional Currencies List 
    _populateStripeCurrenciesToList(
      stripePrice.currency_options, 
      stripePrice.recurrence.interval, 
      stripePrice.recurrence.interval_count,
      stripePrice.currency
    )
  } 

  function _clearPriceElements() {
    // Clear the Prices List
    stripePriceIdElement.val('').change()
    stripePriceIdElement.empty() 
    stripePriceElement.val('')

    // Clear the Currency Options Element
    _clearStripeCurrencyElements()

    stripePriceDefaultTaxBehaviorElement.val('')
    stripePriceRecurentIntervalElement.val('')
    stripePriceIntervalCountElement.val('')
    stripePriceRecurentIntervalElementDisplay.html('---')
    stripePriceDefaultCurrencyElement.val('') // Clear the default currency
  }


   // Append Stripe Currencies
  function _populateStripeCurrenciesToList(currencies, interval, interval_count, defaultCurrency) {
    var selectedValues = stripeCurrencyOptionsElement.val()
    stripeCurrencyOptionsElement.empty() // Clear the List

    Object.keys(currencies).forEach( function(currency){    
      if(defaultCurrency !== currency){
        var amount = currencies[currency].unit_amount 
        var taxBehavior = currencies[currency].tax_behavior
        var currencyID = _currencyIDConstructor(amount, currency, taxBehavior) 
        var label = _formatAmount(amount, currency) + " / " + _generatePriceRecurrentIntervalLabel(interval, interval_count)
        var newOption = new Option(label, currencyID, false, false);
        stripeCurrencyOptionsElement.append(newOption)
      }
    })

    // Refresh List 
    stripeCurrencyOptionsElement.val(selectedValues).trigger('change');
    stripeCurrencyOptionsElement.trigger('select2:select');
  }

  function _generatePriceRecurrentIntervalLabel(interval, interval_count){
    var label = interval
    if(interval_count > 1){
      label = "every " + interval_count + " " + interval + "s"
    }
    return label
  }

  function _currencyIDConstructor(amount, currency, taxBehavior){

    return `amount:${amount}|currency:${currency}|tax_behavior:${taxBehavior}`
  }

  function _clearStripeCurrencyElements(){
    // Clear the Currency Options Element
    stripeCurrencyOptionsElement.val('').change()
    stripeCurrencyOptionsElement.empty() 
  }

  function _formatAmount(val, currency) {
    var dollars = val / 100;
    return dollars.toLocaleString("en-US", {
      style:"currency", currency: String(currency).toUpperCase()
    });
  }

}( window.app ||= {}, 
  window.app.subscriptionPlanForm ||= {}, 
  jQuery 
));


(function ($) {
  $(function() {
    // INIT the Susbcription Plans - New/Edit Page
    if ($('#new_subscription_plan').length || $('#edit_subscription_plan').length) {
      app.subscriptionPlanForm.initForm();
    }
  })
})(jQuery);
